<!--
 * @Descripttion:
 * @version: 1.0
 * @Author: qiye
 * @Date: 2019-09-29 17:13:07
 * @LastEditors: qiye
 * @LastEditTime: 2019-10-28 14:32:28
 -->
<template>
  <div id="app">
    <v-header></v-header>
    <router-view />
    <v-sidebar></v-sidebar>
    <v-footer> </v-footer>

  </div>
</template>

<script>
import header from "@/components/common/header";
import footer from "@/components/common/footer";
import sidebar from "@/components/common/sidebar";
export default {
  name: "App",
  data() {
    return {

    };
  },
  components: {
    "v-header": header,
    "v-footer": footer,
    "v-sidebar":sidebar
  },
  mounted () {

  }
};
</script>

<style lang="stylus"></style>



// WEBPACK FOOTER //
// src/App.vue